<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Vue from "vue";
import EasySlider from "vue-easy-slider";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import { debounce } from "../../../helpers/helper";

Vue.use(EasySlider);
//import store from '@/state/store'
/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    const { perPage, status, orderBy, sortBy } = this.$route.query;
    return {
      moment,
      user: {
        id: "",
        name: "",
        email: "",
        country_code: "",
        phone: "",
        address: "",
        user_inventment_asset: "",
        user_inventment_style: "",
        user_inventment_type: "",
        image: "",
        edit_image: "",
      },
      sortBy: sortBy || "created_at",
      sortDesc: orderBy && orderBy != "" ? orderBy : true,
      status: status == undefined ? "" : status,
      search: "",
      limit: 10,
      isActive: false,
      perPage: perPage || 10,
      postData: "",
      searchData: debounce((type) => {
        const { perPage, status, orderBy, sortBy } = this.$data;
        let id = this.$route.params.id;
        let page = 1;
        this.$router.replace({
          name: "follower.show",
          params: { id: id },
          query: { perPage, status, orderBy, sortBy },
        });
        if (type == 1) {
          this.getPosts({
            page: page,
            perPage: this.perPage,
            search: this.search,
            status: this.status,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
            id: id,
          });
        } else if (type == 2) {
          this.getFollowers({
            page: page,
            perPage: this.perPage,
            search: this.search,
            status: this.status,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
            id: id,
          });
        } else if (type == 3) {
          this.getFollowings({
            page: page,
            perPage: this.perPage,
            search: this.search,
            status: this.status,
            sortBy: this.sortBy,
            orderBy: this.sortDesc ? "desc" : "asc",
            id: id,
          });
        } else {
          console.log("error");
        }
      }, 500),
      fields: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "post_description",
          label: this.$t("companyManagement.list.description"),
          sortable: true,
          tdClass: "w-75",
        },
        {
          key: "website_url",
          label: this.$t("companyManagement.list.websiteurl"),
          sortable: true,
          tdClass: "w-75",
        },
        {
          key: "is_active",
          label: this.$t("userManagement.list.status"),
          sortable: false,
        },
        {
          key: "action",
          label: this.$t("userManagement.list.action"),
          sortable: false,
        },
      ],
      usersData: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "name",
          label: this.$t("userManagement.list.name"),
          sortable: true,
          tdClass: "w-95",
        },

        // {
        //   key: "is_active",
        //   label: this.$t("userManagement.list.status"),
        //   sortable: false,
        // },
      ],
      followingsData: [
        {
          key: "id",
          label: this.$t("userManagement.list.ID"),
          sortable: true,
        },
        {
          key: "name",
          label: this.$t("userManagement.list.name"),
          sortable: true,
          tdClass: "w-75",
        },
        {
          key: "type",
          label: this.$t("userManagement.list.type"),
          sortable: true,
          tdClass: "w-75",
        },
        // {
        //   key: "is_active",
        //   label: this.$t("userManagement.list.status"),
        //   sortable: false,
        // },
      ],
      title: "Users",
      disabled: false,
      isHidden: true,
      showSidebar: false,
      like_users: "",
      post_image: process.env.VUE_APP_MIX_BASE_URL + "images/download.png",
      user_image: process.env.VUE_APP_MIX_BASE_URL + "images/user.png",
      company_image: process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png",
      image_url: process.env.VUE_APP_MIX_BASE_URL + "media/user/original",
      default_image: process.env.VUE_APP_MIX_BASE_URL + "images/download.png",
      active_el: 2,
      seen: true,
      type: 1,
      commentSeen: false,
      commentData: {
        comment: "",
      },
      items: [
        {
          text: "user",
          href: "/users",
        },
        {
          text: "View",
          active: true,
        },
      ],
      assetTable: {
        width: "750px",
      },
      styleTable: {
        width: "750px",
      },
      typeTable: {
        width: "750px",
      },
      investmentTable: {
        margin_top: "30px",
      },
    };
  },
  computed: mapGetters("follower", [
    "loading",
    "users",
    "userData",
    "users",
    "paginations",
    "followers",
    "followings",
    "posts",
    "postDatas",
    "followingCount",
    "followerCount",
  ]),
  mounted() {
    let id = this.$route.params.id;
    this.showUserName(id);
    let page = 1;
    let orderBy = this.sortDesc ? "desc" : "asc";
    this.getPosts({
      page: page,
      perPage: this.perPage,
      search: this.search,
      status: this.status,
      sortBy: this.sortBy,
      orderBy: orderBy,
      id: id,
    });
  },
  methods: {
    ...mapActions("follower", [
      "showFollower",
      "getPosts",
      "getFollowings",
      "getFollowers",
    ]),
    ...mapActions("post", ["showPost", "deletePost", "likePost", "createComment"]),
    showUserName(id) {
      this.showFollower(id).then((res) => {
        this.user.id = res.id;
        this.user.name = res.name;
        this.user.email = res.email;
        this.user.country_code = res.country_code;
        this.user.phone = res.phone_number;
        this.user.address = res.about;
        this.user.user_inventment_asset = res.user_inventment_asset;
        this.user.user_inventment_style = res.user_inventment_style;
        this.user.user_inventment_type = res.user_inventment_type;
        if (res.image) {
          this.user.image =
            process.env.VUE_APP_MIX_BASE_URL + "media/user/original/" + res.image;
        } else {
          this.user.image = process.env.VUE_APP_MIX_BASE_URL + "images/" + "app_icon.png";
        }
      });
    },
    activate: function (el) {
      this.active_el = el;
    },
    getToggelData(id) {
      this.showPost(id).then((res) => {
        this.like_users = res.data.like_users
          .concat(res.data.like_companies)
          .concat(res.data.like_admin);
        this.showSidebar = !this.showSidebar;
      });
      //  document.body.classList.toggle("right-bar-enabled");
    },
    showPostDetail(id) {
      this.showPost(id).then((res) => {
        this.postData = res.data;
      });
    },
    follower(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getFollowers({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
      this.type = 2;
    },
    following(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getFollowings({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
      this.type = 3;
    },
    post(page = 1) {
      let id = this.$route.params.id;

      let orderBy = this.sortDesc ? "desc" : "asc";
      this.getPosts({
        page: page,
        perPage: this.perPage,
        search: this.search,
        status: this.status,
        sortBy: this.sortBy,
        orderBy: orderBy,
        id: id,
      });
      this.type = 1;
    },
    userDetails(id) {
      this.$router.push({ name: "user.detail", params: { id: id } });
    },
    editPostName(id) {
      this.$router.push({ name: "user.post.edit", params: { id: id } });
    },

    deletePostName(id) {
      if (confirm("Do you really want to delete?")) {
        this.deletePost(id).then((res) => {
          if (res.success) {
            window.location.reload();
          }
        });
      }
    },
    hideData() {
      this.isHidden = !this.isHidden;
      this.showSidebar = this.showSidebar;
    },
    imageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/download.png";
    },
    create(post_id) {
      if (this.commentData.comment) {
        this.isActive = true;
        var data = { ...this.commentData, id: post_id };

        this.createComment(data).then((res) => {
          if (res) this.commentData.comment = "";
          this.hideData();
        });
      }
    },
    likes(post_id) {
      this.likePost(post_id).then((res) => {
        if (res.success) {
          this.post(1);
          //this.$router.push({ name: "company.newsfeeds" });
        }
      });
    },
    comments(postId) {
      this.commentSeen = !this.commentSeen;
      this.showPost(postId).then((res) => {
        this.postData = res.data;
      });
    },
    companyimageNotFound(event) {
      event.target.src = process.env.VUE_APP_MIX_BASE_URL + "images/app_icon.png";
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left avatar-main-icon" style="display: flex">
            <div class="avatar-xs mr-3">
              <span
                class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18"
              >
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ user.name }}</h4>
              <p>
                <router-link :to="{ name: 'follower.list' }">Follower</router-link>
                > {{ user.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row list-table-main">
      <div class="col-lg-8 col-xl-9">
        <div class="card">
          <div class="card-body">
            <form>
              <div class="row">
                <input type="hidden" class="form-control" name="id" v-model="user.id" />
                <div class="col-12 mb-2">
                  <div class="form-group" style="display: flex; align-items: center">
                    <a :href="user.image" target="_blank"
                      ><img
                        :src="user.image"
                        width="80"
                        height="80"
                        @error="companyimageNotFound"
                    /></a>
                    <div
                      style="
                        display: flex;
                        align-items: flex-start;
                        flex-direction: column;
                        margin-left: 20px;
                      "
                    >
                      <h4 style="margin-bottom: auto !important">
                        <span> {{ user.name }} </span>
                      </h4>
                      <span class="text-muted">{{ user.email }}</span
                      ><span class="text-muted" v-if="user.country_code && user.phone"
                        >{{ user.country_code }} {{ user.phone }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-2">
                  <b-tabs content-class="mt-3" nav-class="nav-tabs-custom">
                    <b-tab title="Posts" active @click="post">
                      <div class="row list-table-main">
                        <div class="col-12">
                          <div class="card">
                            <div class="card-body">
                              <div class="justify-content-center row" v-if="isHidden">
                                <div class="col-xl-11">
                                  <div>
                                    <div class="align-items-center row">
                                      <div class="col-4">
                                        <div>
                                          <h5 class="mb-0">All Post</h5>
                                        </div>
                                      </div>
                                      <div class="col-8">
                                        <div>
                                          <ul class="nav nav-pills justify-content-end">
                                            <li class="nav-item">
                                              <a
                                                class="nav-link"
                                                href="#"
                                                v-on:click="seen = false"
                                                @click="activate(1)"
                                                :class="{ active: active_el == 1 }"
                                              >
                                                <i
                                                  class="mdi mdi-format-list-bulleted"
                                                ></i>
                                              </a>
                                            </li>
                                            <li class="nav-item">
                                              <a
                                                class="nav-link"
                                                href="#"
                                                v-on:click="seen = true"
                                                @click="activate(2)"
                                                :class="{ active: active_el == 2 }"
                                              >
                                                <i class="mdi mdi-view-grid-outline"></i>
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                    <hr class="mb-4" />

                                    <div v-if="posts.total > 0">
                                      <div class="row" v-if="seen">
                                        <div
                                          class="col-sm-6"
                                          v-for="post in posts.data"
                                          :key="post.id"
                                        >
                                          <div class="p-1 border shadow-none card">
                                            <div class="p-3">
                                              <div
                                                style="
                                                  display: flex;
                                                  align-items: center;
                                                  width: 100% !important;
                                                  justify-content: space-between;
                                                "
                                              >
                                                <div
                                                  style="
                                                    display: flex;
                                                    align-items: center;
                                                  "
                                                >
                                                  <b-avatar
                                                    variant="info"
                                                    :src="user.image"
                                                    class="mr-3"
                                                  ></b-avatar>
                                                  <div style="display: grid">
                                                    <a
                                                      class="text-dark"
                                                      href="#"
                                                      v-on:click="isHidden = false"
                                                      @click="showPostDetail(post.id)"
                                                    >
                                                      <span
                                                        class="font-size-15 mr-auto"
                                                        >{{ user.name }}</span
                                                      >
                                                    </a>

                                                    <small
                                                      v-if="post.created_at"
                                                      class="text-muted"
                                                      >{{
                                                        moment(post.created_at).fromNow()
                                                      }}</small
                                                    >
                                                    <small v-else class="text-muted"
                                                      >-</small
                                                    >
                                                  </div>
                                                </div>
                                                <b-dropdown
                                                  class="float-right ml-5"
                                                  toggle-class="text-muted p-0"
                                                  right
                                                  variant="white"
                                                >
                                                  <template v-slot:button-content>
                                                    <i
                                                      class="mdi mdi-dots-horizontal font-size-18"
                                                    ></i>
                                                  </template>
                                                  <b-dropdown-item
                                                    @click="editPostName(post.id)"
                                                    v-if="
                                                      !post.repost_id && !post.parent_post
                                                    "
                                                    >Edit</b-dropdown-item
                                                  >
                                                  <b-dropdown-item
                                                    @click="deletePostName(post.id)"
                                                    >Delete</b-dropdown-item
                                                  >
                                                </b-dropdown>
                                                <!-- <button class="btn" @click="editPostName(post.id)"><i class="bx bx-pencil" aria-hidden="true"></i></button>
                                                      <button class="btn" @click="deletePostName(post.id)"><i class="bx bx-trash"></i></button> -->
                                              </div>
                                            </div>
                                            <input type="hidden" :value="post.id" />
                                            <div v-if="!post.repost_id">
                                              <div class="p-2">
                                                <p
                                                  v-if="post.post_description.length < 80"
                                                >
                                                  <a
                                                    class="text-dark"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="showPostDetail(post.id)"
                                                  >
                                                    {{ post.post_description }}
                                                  </a>
                                                </p>
                                                <p v-else>
                                                  <a
                                                    class="text-dark"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="showPostDetail(post.id)"
                                                  >
                                                    {{
                                                      post.post_description.substring(
                                                        0,
                                                        80
                                                      ) + ".."
                                                    }}
                                                  </a>
                                                </p>
                                              </div>
                                              <div
                                                v-if="
                                                  post.website_url ||
                                                  post.posts_images.length > 0
                                                "
                                              >
                                                <div
                                                  class="position-relative ml-2 mr-2 mb-2"
                                                  v-if="post.website_url"
                                                >
                                                  <div class="repost-border1">
                                                    <a
                                                      :href="post.website_url"
                                                      class="text-primary"
                                                      target="_blank"
                                                    >
                                                      <div
                                                        class=""
                                                        style="width: 100% !important"
                                                      >
                                                        <div
                                                          style="
                                                            display: flex;
                                                            align-items: center;
                                                            width: 100% !important;
                                                            justify-content: space-between;
                                                          "
                                                        >
                                                          <div
                                                            style="
                                                              display: flex;
                                                              align-items: center;
                                                            "
                                                          >
                                                            <img
                                                              :src="
                                                                post.website_detail
                                                                  .website_image
                                                              "
                                                              alt=""
                                                              v-if="
                                                                post.website_detail
                                                                  .website_image
                                                              "
                                                              style="
                                                                width: 100% !important;
                                                                object-fit: cover;
                                                              "
                                                              @error="
                                                                companyimageNotFound
                                                              "
                                                            />
                                                          </div>
                                                        </div>
                                                        <div
                                                          style="
                                                            background-color: #e8e8e8;
                                                            width: 100% !important;
                                                            object-fit: cover;
                                                            padding: 10px;
                                                          "
                                                        >
                                                          <span
                                                            style="color: #000"
                                                            class="text-dark"
                                                            v-if="
                                                              post.website_detail
                                                                .website_title
                                                            "
                                                          >
                                                            <h6>
                                                              {{
                                                                post.website_detail
                                                                  .website_title
                                                              }}
                                                            </h6>
                                                          </span>
                                                          <span
                                                            style="color: #000"
                                                            class="text-dark"
                                                            v-if="
                                                              post.website_detail
                                                                .website_description
                                                            "
                                                          >
                                                            {{
                                                              post.website_detail
                                                                .website_description
                                                            }}
                                                          </span>
                                                        </div>
                                                      </div>
                                                    </a>
                                                  </div>
                                                </div>
                                                <div class="position-relative" v-else>
                                                  <div
                                                    v-if="post.posts_images.length > 1"
                                                  >
                                                    <slider
                                                      animation="fade"
                                                      style="width: 100% !important"
                                                    >
                                                      <slider-item
                                                        v-for="index in post.posts_images"
                                                        :key="index"
                                                      >
                                                        <a
                                                          class="text-dark"
                                                          href="#"
                                                          v-on:click="isHidden = false"
                                                          @click="showPostDetail(post.id)"
                                                        >
                                                          <img
                                                            :src="
                                                              index.image_path +
                                                              '/' +
                                                              index.image
                                                            "
                                                            style="
                                                              height: 300px !important;
                                                              width: 100% !important;
                                                              object-fit: cover;
                                                            "
                                                            @error="imageNotFound"
                                                          />
                                                        </a>
                                                      </slider-item>
                                                    </slider>
                                                  </div>

                                                  <div
                                                    v-else-if="
                                                      post.posts_images.length == 1
                                                    "
                                                  >
                                                    <!-- <a
                                                      class="text-dark"
                                                      href="#"
                                                      v-on:click="isHidden = false"
                                                      @click="showPostDetail(post.id)"
                                                    > -->
                                                    <img
                                                      :src="
                                                        post.posts_images[0].image_path +
                                                        '/' +
                                                        post.posts_images[0].image
                                                      "
                                                      alt=""
                                                      class="img-thumbnail"
                                                      v-if="
                                                        post.posts_images[0].type ==
                                                        'Image'
                                                      "
                                                      style="
                                                        height: auto !important;
                                                        width: 100% !important;
                                                        object-fit: cover;
                                                      "
                                                      @error="imageNotFound"
                                                    />

                                                    <video
                                                      style="
                                                        height: auto !important;
                                                        width: 100% !important;
                                                        object-fit: cover;
                                                      "
                                                      v-if="
                                                        post.posts_images[0].type ==
                                                        'Video'
                                                      "
                                                      controls
                                                      :src="
                                                        post.posts_images[0].image_path +
                                                        '/' +
                                                        post.posts_images[0].image
                                                      "
                                                    ></video>
                                                    <!-- <span
                                                      v-if="
                                                        post.posts_images[0].type == 'File'
                                                      "
                                                      >{{
                                                        post.posts_images[0].image
                                                      }}</span
                                                    > -->

                                                    <div
                                                      class="embed-responsive embed-responsive-16by9"
                                                      v-if="
                                                        post.posts_images[0].type ==
                                                        'File'
                                                      "
                                                      style="
                                                        margin-bottom: -115px !important;
                                                      "
                                                    >
                                                      <iframe
                                                        class="embed-responsive-item vue_frame"
                                                        :src="
                                                          post.posts_images[0]
                                                            .image_path +
                                                          '/' +
                                                          post.posts_images[0].image
                                                        "
                                                      ></iframe>
                                                    </div>
                                                    <!-- </a> -->
                                                  </div>
                                                  <div v-else>
                                                    <a
                                                      class="text-dark"
                                                      href="#"
                                                      v-on:click="isHidden = false"
                                                      @click="showPostDetail(post.id)"
                                                    >
                                                      <img
                                                        :src="default_image"
                                                        alt=""
                                                        class="img-thumbnail"
                                                        style="
                                                          height: auto !important;
                                                          width: 100% !important;
                                                          object-fit: cover;
                                                        "
                                                      />
                                                    </a>
                                                  </div>
                                                </div>
                                              </div>
                                              <div v-else></div>
                                              <div class="p-3">
                                                <ul
                                                  class="list-inline"
                                                  style="
                                                    display: flex;
                                                    justify-content: space-between;
                                                  "
                                                >
                                                  <li class="list-inline-item">
                                                    <a
                                                      class="text-muted"
                                                      href="javascript:void(0)"
                                                      @click="getToggelData(post.id)"
                                                    >
                                                      <i
                                                        class="bx bx-like align-middle text-muted me-1"
                                                      ></i>
                                                      {{ post.like_users.length }} Likes
                                                    </a>
                                                  </li>
                                                  <li class="list-inline-item">
                                                    <a
                                                      class="text-muted"
                                                      href="#"
                                                      v-on:click="isHidden = false"
                                                      @click="showPostDetail(post.id)"
                                                    >
                                                      <i
                                                        class="bx bx-comment-dots align-middle text-muted me-1"
                                                      ></i>
                                                      {{ post.comments.length }} Comments
                                                    </a>
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                            <div class="pl-2 pr-2" v-else>
                                              <div
                                                v-if="post.repost_id && post.parent_post"
                                              >
                                                <div class="repost-border pr-2 pl-2">
                                                  <a
                                                    class="text-dark"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="
                                                      showPostDetail(post.parent_post.id)
                                                    "
                                                  >
                                                    <div class="p-3">
                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                          width: 100% !important;
                                                          justify-content: space-between;
                                                        "
                                                      >
                                                        <div
                                                          style="
                                                            display: flex;
                                                            align-items: center;
                                                          "
                                                          v-if="
                                                            post.parent_post.company &&
                                                            post.parent_post.is_company ==
                                                              1
                                                          "
                                                        >
                                                          <b-avatar
                                                            variant="info"
                                                            :src="
                                                              post.parent_post.company
                                                                .image_path +
                                                              '/' +
                                                              post.parent_post.company
                                                                .image
                                                            "
                                                            class="mr-3"
                                                            v-if="
                                                              post.parent_post.company
                                                                .image
                                                            "
                                                          ></b-avatar>
                                                          <b-avatar
                                                            variant="info"
                                                            :src="company_image"
                                                            class="mr-3"
                                                            v-else
                                                          ></b-avatar>
                                                          <div style="display: grid">
                                                            <span
                                                              class="font-size-15 mr-auto text-dark"
                                                              >{{
                                                                post.parent_post.company
                                                                  .name
                                                              }}</span
                                                            >

                                                            <small
                                                              v-if="
                                                                post.parent_post
                                                                  .created_at
                                                              "
                                                              class="text-muted"
                                                              >{{
                                                                moment(
                                                                  post.parent_post
                                                                    .created_at
                                                                ).fromNow()
                                                              }}
                                                            </small>
                                                            <small
                                                              v-else
                                                              class="text-muted"
                                                              >-</small
                                                            >
                                                          </div>
                                                        </div>

                                                        <div
                                                          style="
                                                            display: flex;
                                                            align-items: center;
                                                          "
                                                          v-if="
                                                            post.parent_post.user &&
                                                            post.parent_post.is_company ==
                                                              0
                                                          "
                                                        >
                                                          <b-avatar
                                                            variant="info"
                                                            :src="
                                                              post.parent_post.user
                                                                .image_original_url
                                                            "
                                                            class="mr-3"
                                                            v-if="
                                                              post.parent_post.user
                                                                .image_original_url
                                                            "
                                                          ></b-avatar>
                                                          <b-avatar
                                                            variant="info"
                                                            :src="user_image"
                                                            class="mr-3"
                                                            v-else
                                                          ></b-avatar>
                                                          <div style="display: grid">
                                                            <span
                                                              class="font-size-15 mr-auto text-dark"
                                                              >{{
                                                                post.parent_post.user.name
                                                              }}</span
                                                            >

                                                            <small
                                                              v-if="
                                                                post.parent_post
                                                                  .created_at
                                                              "
                                                              class="text-muted"
                                                              >{{
                                                                moment(
                                                                  post.parent_post
                                                                    .created_at
                                                                ).fromNow()
                                                              }}</small
                                                            >
                                                            <small
                                                              v-else
                                                              class="text-muted"
                                                              >-</small
                                                            >
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="pl-3 pr-3">
                                                      <div
                                                        v-html="
                                                          post.parent_post
                                                            .post_description
                                                        "
                                                        id="app"
                                                        style="white-space: pre-wrap"
                                                        class="text-dark"
                                                        v-if="
                                                          post.parent_post
                                                            .post_description.length < 500
                                                        "
                                                      ></div>

                                                      <div
                                                        v-html="
                                                          post.parent_post.post_description.substring(
                                                            0,
                                                            500
                                                          ) + '..'
                                                        "
                                                        id="app"
                                                        style="white-space: pre-wrap"
                                                        class="text-dark pt-3"
                                                        v-else
                                                      ></div>
                                                      <div
                                                        v-if="
                                                          post.parent_post
                                                            .post_description.length > 500
                                                        "
                                                        class="mb-2"
                                                      >
                                                        <router-link
                                                          :to="{
                                                            name:
                                                              'company.newsfeeds.show',
                                                            params: { id: post.id },
                                                          }"
                                                          class="text-primary"
                                                          >Read more
                                                          <i
                                                            class="mdi mdi-arrow-right"
                                                          ></i
                                                        ></router-link>
                                                      </div>

                                                      <div
                                                        v-if="
                                                          post.parent_post.website_url ||
                                                          post.parent_post.posts_images
                                                            .length > 0
                                                        "
                                                      >
                                                        <div
                                                          class="position-relative mb-3 mt-3"
                                                          v-if="
                                                            post.parent_post.website_url
                                                          "
                                                        >
                                                          <div class="repost-border1">
                                                            <a
                                                              :href="
                                                                post.parent_post
                                                                  .website_url
                                                              "
                                                              class="text-primary"
                                                              target="_blank"
                                                            >
                                                              <div
                                                                class=""
                                                                style="
                                                                  width: 100% !important;
                                                                "
                                                              >
                                                                <div
                                                                  style="
                                                                    display: flex;
                                                                    align-items: center;
                                                                    width: 100% !important;
                                                                    justify-content: space-between;
                                                                  "
                                                                >
                                                                  <div
                                                                    style="
                                                                      display: flex;
                                                                      align-items: center;
                                                                    "
                                                                  >
                                                                    <img
                                                                      :src="
                                                                        post.parent_post
                                                                          .website_detail
                                                                          .website_image
                                                                      "
                                                                      alt=""
                                                                      v-if="
                                                                        post.parent_post
                                                                          .website_detail
                                                                          .website_image
                                                                      "
                                                                      style="
                                                                        width: 100% !important;
                                                                        object-fit: cover;
                                                                      "
                                                                      @error="
                                                                        companyimageNotFound
                                                                      "
                                                                    />
                                                                  </div>
                                                                </div>
                                                                <div
                                                                  style="
                                                                    background-color: #e8e8e8;
                                                                    width: 100% !important;
                                                                    object-fit: cover;
                                                                    padding: 10px;
                                                                  "
                                                                >
                                                                  <span
                                                                    style="color: #000"
                                                                    class="text-dark"
                                                                    v-if="
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_title
                                                                    "
                                                                  >
                                                                    <h6>
                                                                      {{
                                                                        post.parent_post
                                                                          .website_detail
                                                                          .website_title
                                                                      }}
                                                                    </h6>
                                                                  </span>
                                                                  <span
                                                                    style="color: #000"
                                                                    class="text-dark"
                                                                    v-if="
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_description
                                                                    "
                                                                  >
                                                                    {{
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_description
                                                                    }}
                                                                  </span>
                                                                </div>
                                                              </div>
                                                            </a>
                                                          </div>
                                                        </div>
                                                        <div
                                                          class="position-relative mb-3 mt-3"
                                                          v-else
                                                        >
                                                          <div
                                                            v-if="
                                                              post.parent_post
                                                                .posts_images.length > 1
                                                            "
                                                          >
                                                            <slider
                                                              animation="fade"
                                                              height="400px"
                                                              width="auto"
                                                            >
                                                              <slider-item
                                                                v-for="(
                                                                  image, index
                                                                ) in post.parent_post
                                                                  .posts_images"
                                                                :key="index"
                                                              >
                                                                <img
                                                                  :src="
                                                                    image.image_path +
                                                                    '/' +
                                                                    image.image
                                                                  "
                                                                  width="665px;"
                                                                  style="
                                                                    height: 400px !important;
                                                                  "
                                                                  @error="imageNotFound"
                                                                />
                                                              </slider-item>
                                                            </slider>
                                                          </div>
                                                          <div
                                                            v-else-if="
                                                              post.parent_post
                                                                .posts_images.length == 1
                                                            "
                                                          >
                                                            <video
                                                              style="
                                                                height: auto !important;
                                                                width: 100% !important;
                                                                object-fit: cover;
                                                              "
                                                              v-if="
                                                                post.parent_post
                                                                  .posts_images[0].type ==
                                                                'Video'
                                                              "
                                                              controls
                                                              :src="
                                                                post.parent_post
                                                                  .posts_images[0]
                                                                  .image_path +
                                                                '/' +
                                                                post.parent_post
                                                                  .posts_images[0].image
                                                              "
                                                            ></video>

                                                            <img
                                                              :src="
                                                                post.parent_post
                                                                  .posts_images[0]
                                                                  .image_path +
                                                                '/' +
                                                                post.parent_post
                                                                  .posts_images[0].image
                                                              "
                                                              alt=""
                                                              v-if="
                                                                post.parent_post
                                                                  .posts_images[0].type ==
                                                                'Image'
                                                              "
                                                              class="img-thumbnail"
                                                              width="100%;"
                                                              @error="imageNotFound"
                                                            />
                                                            <!-- style="
                                                                height: 100px !important;
                                                                width: 100% !important;
                                                              " -->
                                                            <div
                                                              class="embed-responsive embed-responsive-16by9"
                                                              v-if="
                                                                post.parent_post
                                                                  .posts_images[0].type ==
                                                                'File'
                                                              "
                                                            >
                                                              <iframe
                                                                class="embed-responsive-item vue_frame"
                                                                :src="
                                                                  post.parent_post
                                                                    .posts_images[0]
                                                                    .image_path +
                                                                  '/' +
                                                                  post.parent_post
                                                                    .posts_images[0].image
                                                                "
                                                              ></iframe>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div v-else></div>
                                                      <ul
                                                        class="list-inline"
                                                        style="
                                                          display: flex;
                                                          justify-content: space-between;
                                                        "
                                                      >
                                                        <li class="list-inline-item">
                                                          <i
                                                            class="bx bx-like align-middle text-muted me-1"
                                                          ></i>

                                                          {{
                                                            post.parent_post.like_admin
                                                              .length +
                                                            post.parent_post
                                                              .like_companies.length +
                                                            post.parent_post.like_users
                                                              .length
                                                          }}
                                                          Likes
                                                        </li>
                                                        <li class="list-inline-item">
                                                          <i
                                                            class="bx bx-comment-dots align-middle text-muted me-1"
                                                          ></i>
                                                          {{
                                                            post.parent_post.comments
                                                              .length
                                                          }}
                                                          Comments
                                                        </li>
                                                      </ul>
                                                    </div>
                                                  </a>
                                                </div>
                                                <ul
                                                  class="list-inline mt-3 mb-0"
                                                  style="
                                                    display: flex;
                                                    justify-content: space-between;
                                                  "
                                                >
                                                  <li class="list-inline-item">
                                                    <a
                                                      class="text-muted"
                                                      href="javascript:void(0)"
                                                      @click="getToggelData(post.id)"
                                                      ><i
                                                        class="bx bx-like align-middle text-muted me-1"
                                                      ></i>
                                                      {{
                                                        post.like_users.length +
                                                        post.like_companies.length +
                                                        post.like_admin.length
                                                      }}
                                                      Likes</a
                                                    >
                                                  </li>
                                                  <li class="list-inline-item">
                                                    <a
                                                      class="text-muted"
                                                      :href="'/company/show/' + post.id"
                                                    >
                                                      <i
                                                        class="bx bx-comment-dots align-middle text-muted me-1"
                                                      ></i>
                                                      {{ post.comments.length }}
                                                      Comments</a
                                                    >
                                                  </li>
                                                </ul>
                                              </div>
                                            </div>
                                            <hr class="my-1" />
                                            <div class="pl-3 pr-3 pt-2">
                                              <ul
                                                class="list-inline text-muted"
                                                style="
                                                  display: flex;
                                                  justify-content: space-between;
                                                "
                                              >
                                                <li
                                                  class="list-inline-item w-50 likes-post"
                                                  v-if="post.like_admin.length > 0"
                                                  style="text-align: center"
                                                >
                                                  <a
                                                    @click="likes(post.id)"
                                                    class="text-muted"
                                                    href="javascript:void(0)"
                                                  >
                                                    <i
                                                      class="bx bxs-like align-middle text-muted me-1 bx-sm"
                                                    ></i>
                                                  </a>
                                                </li>
                                                <li
                                                  class="list-inline-item w-50 likes-post"
                                                  v-else
                                                  style="text-align: center"
                                                >
                                                  <a
                                                    @click="likes(post.id)"
                                                    class="text-muted"
                                                    href="javascript:void(0)"
                                                  >
                                                    <i
                                                      class="bx bx-like align-middle text-muted me-1 bx-sm"
                                                    ></i>
                                                  </a>
                                                </li>

                                                <li
                                                  class="list-inline-item w-50"
                                                  style="text-align: center"
                                                >
                                                  <a
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="comments(post.id)"
                                                    class="text-muted"
                                                  >
                                                    <i
                                                      class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                                                    ></i>
                                                  </a>
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row" v-else>
                                        <div
                                          class="col-sm-12"
                                          v-for="post in posts.data"
                                          :key="post.id"
                                        >
                                          <div
                                            style="
                                              display: flex;
                                              align-items: center;
                                              width: 100% !important;
                                              justify-content: space-between;
                                            "
                                          >
                                            <div
                                              style="display: flex; align-items: center"
                                            >
                                              <b-avatar
                                                variant="info"
                                                :src="user.image"
                                                class="mr-3"
                                              ></b-avatar>
                                              <div style="display: grid">
                                                <a
                                                  class="text-dark"
                                                  href="#"
                                                  v-on:click="isHidden = false"
                                                  @click="showPostDetail(post.id)"
                                                >
                                                  <span class="font-size-15 mr-auto">{{
                                                    user.name
                                                  }}</span>
                                                </a>

                                                <small
                                                  v-if="post.created_at"
                                                  class="text-muted"
                                                  >{{
                                                    moment(post.created_at).fromNow()
                                                  }}</small
                                                >
                                                <small v-else class="text-muted">-</small>
                                              </div>
                                            </div>
                                            <b-dropdown
                                              class="float-right ml-5"
                                              toggle-class="text-muted p-0"
                                              right
                                              variant="white"
                                            >
                                              <template v-slot:button-content>
                                                <i
                                                  class="mdi mdi-dots-horizontal font-size-18"
                                                ></i>
                                              </template>
                                              <b-dropdown-item
                                                @click="editPostName(post.id)"
                                                v-if="
                                                  !post.repost_id && !post.parent_post
                                                "
                                                >Edit</b-dropdown-item
                                              >
                                              <b-dropdown-item
                                                @click="deletePostName(post.id)"
                                                >Delete</b-dropdown-item
                                              >
                                            </b-dropdown>
                                          </div>
                                          <input type="hidden" :value="post.id" />
                                          <div v-if="!post.repost_id">
                                            <p
                                              v-if="post.post_description.length < 500"
                                              class="mt-3"
                                            >
                                              <a
                                                class="text-dark"
                                                href="#"
                                                v-on:click="isHidden = false"
                                                @click="showPostDetail(post.id)"
                                              >
                                                {{ post.post_description }}
                                              </a>
                                            </p>
                                            <p v-else class="mt-3">
                                              <a
                                                class="text-dark"
                                                href="#"
                                                v-on:click="isHidden = false"
                                                @click="showPostDetail(post.id)"
                                              >
                                                {{
                                                  post.post_description.substring(
                                                    0,
                                                    500
                                                  ) + ".."
                                                }}
                                              </a>
                                            </p>
                                            <div
                                              v-if="
                                                post.website_url ||
                                                post.posts_images.length
                                              "
                                            >
                                              <div
                                                class="position-relative mb-3 mt-3"
                                                v-if="post.website_url"
                                              >
                                                <div class="repost-border1">
                                                  <a
                                                    :href="post.website_url"
                                                    class="text-primary"
                                                    target="_blank"
                                                  >
                                                    <div
                                                      class=""
                                                      style="width: 100% !important"
                                                    >
                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                          width: 100% !important;
                                                          justify-content: space-between;
                                                        "
                                                      >
                                                        <div
                                                          style="
                                                            display: flex;
                                                            align-items: center;
                                                          "
                                                        >
                                                          <img
                                                            :src="
                                                              post.website_detail
                                                                .website_image
                                                            "
                                                            alt=""
                                                            v-if="
                                                              post.website_detail
                                                                .website_image
                                                            "
                                                            style="
                                                              width: 100% !important;
                                                              object-fit: cover;
                                                            "
                                                            @error="companyimageNotFound"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div
                                                        style="
                                                          background-color: #e8e8e8;
                                                          width: 100% !important;
                                                          object-fit: cover;
                                                          padding: 10px;
                                                        "
                                                      >
                                                        <span
                                                          style="color: #000"
                                                          class="text-dark"
                                                          v-if="
                                                            post.website_detail
                                                              .website_title
                                                          "
                                                        >
                                                          <h6>
                                                            {{
                                                              post.website_detail
                                                                .website_title
                                                            }}
                                                          </h6>
                                                        </span>
                                                        <span
                                                          style="color: #000"
                                                          class="text-dark"
                                                          v-if="
                                                            post.website_detail
                                                              .website_description
                                                          "
                                                        >
                                                          {{
                                                            post.website_detail
                                                              .website_description
                                                          }}
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </a>
                                                </div>
                                              </div>
                                              <div
                                                class="position-relative mb-3 mt-3"
                                                v-else
                                              >
                                                <div v-if="post.posts_images.length > 1">
                                                  <slider
                                                    animation="fade"
                                                    style="width: 100% !important"
                                                  >
                                                    <slider-item
                                                      v-for="index in post.posts_images"
                                                      :key="index"
                                                    >
                                                      <a
                                                        class="text-dark"
                                                        href="#"
                                                        v-on:click="isHidden = false"
                                                        @click="showPostDetail(post.id)"
                                                      >
                                                        <img
                                                          :src="
                                                            index.image_path +
                                                            '/' +
                                                            index.image
                                                          "
                                                          style="
                                                            height: 300px !important;
                                                            width: 100% !important;
                                                            object-fit: cover;
                                                          "
                                                          @error="imageNotFound"
                                                        />
                                                      </a>
                                                    </slider-item>
                                                  </slider>
                                                </div>
                                                <div
                                                  v-else-if="
                                                    post.posts_images.length == 1
                                                  "
                                                >
                                                  <!-- <a
                                                    class="text-dark"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="showPostDetail(post.id)"
                                                  > -->
                                                  <img
                                                    :src="
                                                      post.posts_images[0].image_path +
                                                      '/' +
                                                      post.posts_images[0].image
                                                    "
                                                    alt=""
                                                    v-if="
                                                      post.posts_images[0].type == 'Image'
                                                    "
                                                    class="img-thumbnail"
                                                    style="
                                                      height: auto !important;
                                                      width: 100% !important;
                                                      object-fit: cover;
                                                    "
                                                    @error="imageNotFound"
                                                  />
                                                  <video
                                                    style="
                                                      height: auto !important;
                                                      width: 100% !important;
                                                      object-fit: cover;
                                                    "
                                                    v-if="
                                                      post.posts_images[0].type == 'Video'
                                                    "
                                                    controls
                                                    :src="
                                                      post.posts_images[0].image_path +
                                                      '/' +
                                                      post.posts_images[0].image
                                                    "
                                                  ></video>
                                                  <div
                                                    class="embed-responsive embed-responsive-16by9"
                                                    v-if="
                                                      post.posts_images[0].type == 'File'
                                                    "
                                                    style="
                                                      margin-bottom: -115px !important;
                                                    "
                                                  >
                                                    <iframe
                                                      class="embed-responsive-item vue_frame"
                                                      :src="
                                                        post.posts_images[0].image_path +
                                                        '/' +
                                                        post.posts_images[0].image
                                                      "
                                                    ></iframe>
                                                  </div>

                                                  <!-- </a> -->
                                                </div>
                                                <div v-else>
                                                  <a
                                                    class="text-dark"
                                                    href="#"
                                                    v-on:click="isHidden = false"
                                                    @click="showPostDetail(post.id)"
                                                  >
                                                    <img
                                                      :src="default_image"
                                                      alt=""
                                                      class="img-thumbnail"
                                                      style="
                                                        width: 100% !important;
                                                        object-fit: cover;
                                                      "
                                                    />
                                                  </a>
                                                  <!-- height: 300px !important; -->
                                                </div>
                                              </div>
                                            </div>
                                            <div v-else></div>
                                            <ul
                                              class="list-inline pt-2"
                                              style="
                                                display: flex;
                                                justify-content: space-between;
                                              "
                                            >
                                              <li class="list-inline-item">
                                                <a
                                                  class="text-muted"
                                                  href="javascript:void(0)"
                                                  @click="getToggelData(post.id)"
                                                  ><i
                                                    class="bx bx-like align-middle text-muted me-1"
                                                  ></i>
                                                  {{ post.like_users.length }} Likes</a
                                                >
                                              </li>
                                              <li class="list-inline-item">
                                                <a
                                                  class="text-muted"
                                                  href="#"
                                                  v-on:click="isHidden = false"
                                                  @click="showPostDetail(post.id)"
                                                >
                                                  <i
                                                    class="bx bx-comment-dots align-middle text-muted me-1"
                                                  ></i>
                                                  {{ post.comments.length }} Comments</a
                                                >
                                              </li>
                                            </ul>
                                          </div>
                                          <div class="pb-3 pt-3 pr-2 pl-2" v-else>
                                            <div
                                              v-if="post.repost_id && post.parent_post"
                                            >
                                              <div class="repost-border pr-2 pl-2">
                                                <a
                                                  class="text-dark"
                                                  href="#"
                                                  v-on:click="isHidden = false"
                                                  @click="
                                                    showPostDetail(post.parent_post.id)
                                                  "
                                                >
                                                  <div class="p-3">
                                                    <div
                                                      style="
                                                        display: flex;
                                                        align-items: center;
                                                        width: 100% !important;
                                                        justify-content: space-between;
                                                      "
                                                    >
                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                        "
                                                        v-if="
                                                          post.parent_post.company &&
                                                          post.parent_post.is_company == 1
                                                        "
                                                      >
                                                        <b-avatar
                                                          variant="info"
                                                          :src="
                                                            post.parent_post.company
                                                              .image_url
                                                          "
                                                          class="mr-3"
                                                          v-if="
                                                            post.parent_post.company.image
                                                          "
                                                        ></b-avatar>
                                                        <b-avatar
                                                          variant="info"
                                                          :src="company_image"
                                                          class="mr-3"
                                                          v-else
                                                        ></b-avatar>
                                                        <div style="display: grid">
                                                          <span
                                                            class="font-size-15 mr-auto text-dark"
                                                            >{{
                                                              post.parent_post.company
                                                                .name
                                                            }}</span
                                                          >
                                                          <small
                                                            v-if="
                                                              post.parent_post.created_at
                                                            "
                                                            class="text-muted"
                                                            >{{
                                                              moment(
                                                                post.parent_post
                                                                  .created_at
                                                              ).fromNow()
                                                            }}
                                                          </small>
                                                          <small v-else class="text-muted"
                                                            >-</small
                                                          >
                                                        </div>
                                                      </div>

                                                      <div
                                                        style="
                                                          display: flex;
                                                          align-items: center;
                                                        "
                                                        v-if="
                                                          post.parent_post.user &&
                                                          post.parent_post.is_company == 0
                                                        "
                                                      >
                                                        <b-avatar
                                                          variant="info"
                                                          :src="
                                                            post.parent_post.user
                                                              .image_url
                                                          "
                                                          class="mr-3"
                                                          v-if="
                                                            post.parent_post.user.image
                                                          "
                                                        ></b-avatar>
                                                        <b-avatar
                                                          variant="info"
                                                          :src="user_image"
                                                          class="mr-3"
                                                          v-else
                                                        ></b-avatar>
                                                        <div style="display: grid">
                                                          <span
                                                            class="font-size-15 mr-auto text-dark"
                                                            >{{
                                                              post.parent_post.user.name
                                                            }}</span
                                                          >

                                                          <small
                                                            v-if="
                                                              post.parent_post.created_at
                                                            "
                                                            class="text-muted"
                                                            >{{
                                                              moment(
                                                                post.parent_post
                                                                  .created_at
                                                              ).fromNow()
                                                            }}</small
                                                          >
                                                          <small v-else class="text-muted"
                                                            >-</small
                                                          >
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="pl-3 pr-3">
                                                    <div
                                                      v-html="
                                                        post.parent_post.post_description
                                                      "
                                                      id="app"
                                                      style="white-space: pre-wrap"
                                                      class="text-dark"
                                                      v-if="
                                                        post.parent_post.post_description
                                                          .length < 500
                                                      "
                                                    ></div>

                                                    <div
                                                      v-html="
                                                        post.parent_post.post_description.substring(
                                                          0,
                                                          500
                                                        ) + '..'
                                                      "
                                                      id="app"
                                                      style="white-space: pre-wrap"
                                                      class="text-dark pt-3"
                                                      v-else
                                                    ></div>
                                                    <div
                                                      v-if="
                                                        post.parent_post.post_description
                                                          .length > 500
                                                      "
                                                      class="mb-2"
                                                    >
                                                      <router-link
                                                        :to="{
                                                          name: 'company.newsfeeds.show',
                                                          params: { id: post.id },
                                                        }"
                                                        class="text-primary"
                                                        >Read more
                                                        <i class="mdi mdi-arrow-right"></i
                                                      ></router-link>
                                                    </div>

                                                    <div
                                                      v-if="
                                                        post.parent_post.website_url ||
                                                        post.parent_post.posts_images
                                                          .length > 0
                                                      "
                                                    >
                                                      <div
                                                        class="position-relative mb-3 mt-3"
                                                        v-if="
                                                          post.parent_post.website_url
                                                        "
                                                      >
                                                        <div class="repost-border1">
                                                          <a
                                                            :href="
                                                              post.parent_post.website_url
                                                            "
                                                            class="text-primary"
                                                            target="_blank"
                                                          >
                                                            <div
                                                              class=""
                                                              style="
                                                                width: 100% !important;
                                                              "
                                                            >
                                                              <div
                                                                style="
                                                                  display: flex;
                                                                  align-items: center;
                                                                  width: 100% !important;
                                                                  justify-content: space-between;
                                                                "
                                                              >
                                                                <div
                                                                  style="
                                                                    display: flex;
                                                                    align-items: center;
                                                                  "
                                                                >
                                                                  <img
                                                                    :src="
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_image
                                                                    "
                                                                    alt=""
                                                                    v-if="
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_image
                                                                    "
                                                                    style="
                                                                      width: 100% !important;
                                                                      object-fit: cover;
                                                                    "
                                                                    @error="
                                                                      companyimageNotFound
                                                                    "
                                                                  />
                                                                </div>
                                                              </div>
                                                              <div
                                                                style="
                                                                  background-color: #e8e8e8;
                                                                  width: 100% !important;
                                                                  object-fit: cover;
                                                                  padding: 10px;
                                                                "
                                                              >
                                                                <span
                                                                  style="color: #000"
                                                                  class="text-dark"
                                                                  v-if="
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_title
                                                                  "
                                                                >
                                                                  <h6>
                                                                    {{
                                                                      post.parent_post
                                                                        .website_detail
                                                                        .website_title
                                                                    }}
                                                                  </h6>
                                                                </span>
                                                                <span
                                                                  style="color: #000"
                                                                  class="text-dark"
                                                                  v-if="
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_description
                                                                  "
                                                                >
                                                                  {{
                                                                    post.parent_post
                                                                      .website_detail
                                                                      .website_description
                                                                  }}
                                                                </span>
                                                              </div>
                                                            </div>
                                                          </a>
                                                        </div>
                                                      </div>
                                                      <div
                                                        class="position-relative mb-3 mt-3"
                                                        v-else
                                                      >
                                                        <div
                                                          v-if="
                                                            post.parent_post.posts_images
                                                              .length > 1
                                                          "
                                                        >
                                                          <slider
                                                            animation="fade"
                                                            height="400px"
                                                            width="auto"
                                                          >
                                                            <slider-item
                                                              v-for="(
                                                                image, index
                                                              ) in post.parent_post
                                                                .posts_images"
                                                              :key="index"
                                                            >
                                                              <img
                                                                :src="
                                                                  image.image_path +
                                                                  '/' +
                                                                  image.image
                                                                "
                                                                width="665px;"
                                                                style="
                                                                  height: 400px !important;
                                                                "
                                                                @error="imageNotFound"
                                                              />
                                                            </slider-item>
                                                          </slider>
                                                        </div>
                                                        <div
                                                          v-else-if="
                                                            post.parent_post.posts_images
                                                              .length == 1
                                                          "
                                                        >
                                                          <video
                                                            style="
                                                              height: auto !important;
                                                              width: 100% !important;
                                                              object-fit: cover;
                                                            "
                                                            v-if="
                                                              post.parent_post
                                                                .posts_images[0].type ==
                                                              'Video'
                                                            "
                                                            controls
                                                            :src="
                                                              post.parent_post
                                                                .posts_images[0]
                                                                .image_path +
                                                              '/' +
                                                              post.parent_post
                                                                .posts_images[0].image
                                                            "
                                                          ></video>

                                                          <img
                                                            :src="
                                                              post.parent_post
                                                                .posts_images[0]
                                                                .image_path +
                                                              '/' +
                                                              post.parent_post
                                                                .posts_images[0].image
                                                            "
                                                            alt=""
                                                            v-if="
                                                              post.parent_post
                                                                .posts_images[0].type ==
                                                              'Image'
                                                            "
                                                            class="img-thumbnail"
                                                            width="100% "
                                                            @error="imageNotFound"
                                                          />
                                                          <!-- style="
                                                              height: 250px !important;
                                                              width: 100% !important;
                                                            " -->
                                                          <div
                                                            class="embed-responsive embed-responsive-16by9"
                                                            v-if="
                                                              post.parent_post
                                                                .posts_images[0].type ==
                                                              'File'
                                                            "
                                                          >
                                                            <iframe
                                                              class="embed-responsive-item vue_frame"
                                                              :src="
                                                                post.parent_post
                                                                  .posts_images[0]
                                                                  .image_path +
                                                                '/' +
                                                                post.parent_post
                                                                  .posts_images[0].image
                                                              "
                                                            ></iframe>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div v-else></div>
                                                    <ul
                                                      class="list-inline"
                                                      style="
                                                        display: flex;
                                                        justify-content: space-between;
                                                      "
                                                    >
                                                      <li class="list-inline-item">
                                                        <i
                                                          class="bx bx-like align-middle text-muted me-1"
                                                        ></i>
                                                        {{
                                                          post.parent_post.like_admin
                                                            .length +
                                                          post.parent_post.like_companies
                                                            .length +
                                                          post.parent_post.like_users
                                                            .length
                                                        }}
                                                        Likes
                                                      </li>
                                                      <li class="list-inline-item">
                                                        <i
                                                          class="bx bx-comment-dots align-middle text-muted me-1"
                                                        ></i>
                                                        {{
                                                          post.parent_post.comments.length
                                                        }}
                                                        Comments
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </a>
                                              </div>
                                              <ul
                                                class="list-inline pt-3"
                                                style="
                                                  display: flex;
                                                  justify-content: space-between;
                                                "
                                              >
                                                <li class="list-inline-item">
                                                  <a
                                                    class="text-muted"
                                                    href="javascript:void(0)"
                                                    @click="getToggelData(post.id)"
                                                    ><i
                                                      class="bx bx-like align-middle text-muted me-1"
                                                    ></i>
                                                    {{
                                                      post.like_users.length +
                                                      post.like_companies.length +
                                                      post.like_admin.length
                                                    }}
                                                    Likes</a
                                                  >
                                                </li>
                                                <li class="list-inline-item">
                                                  <router-link
                                                    :to="{
                                                      name: 'post.show',
                                                      params: { id: post.id },
                                                    }"
                                                    class="text-muted"
                                                  >
                                                    <i
                                                      class="bx bx-comment-dots align-middle text-muted me-1"
                                                    ></i>
                                                    {{ post.comments.length }} Comments
                                                  </router-link>

                                                  <!-- <a class="text-muted" href="/blog-list"
                                ><i
                                  class="bx bx-comment-dots align-middle text-muted me-1"
                                ></i>
                                {{ post.comment_count }} Comments</a
                              > -->
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                          <hr class="my-1" />
                                          <div class="pl-3 pr-3 pt-2">
                                            <ul
                                              class="list-inline text-muted"
                                              style="
                                                display: flex;
                                                justify-content: space-between;
                                              "
                                            >
                                              <li
                                                class="list-inline-item w-50 likes-post"
                                                v-if="post.like_admin.length > 0"
                                                style="text-align: center"
                                              >
                                                <a
                                                  @click="likes(post.id)"
                                                  class="text-muted"
                                                  href="javascript:void(0)"
                                                >
                                                  <i
                                                    class="bx bxs-like align-middle text-muted me-1 bx-sm"
                                                  ></i>
                                                </a>
                                              </li>
                                              <li
                                                class="list-inline-item w-50 likes-post"
                                                v-else
                                                style="text-align: center"
                                              >
                                                <a
                                                  @click="likes(post.id)"
                                                  class="text-muted"
                                                  href="javascript:void(0)"
                                                >
                                                  <i
                                                    class="bx bx-like align-middle text-muted me-1 bx-sm"
                                                  ></i>
                                                </a>
                                              </li>

                                              <li
                                                class="list-inline-item w-50"
                                                style="text-align: center"
                                              >
                                                <a
                                                  href="#"
                                                  v-on:click="isHidden = false"
                                                  @click="comments(post.id)"
                                                  class="text-muted"
                                                >
                                                  <i
                                                    class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                                                  ></i>
                                                </a>
                                              </li>
                                            </ul>
                                          </div>
                                          <hr class="mb-5" v-if="posts.data.length > 1" />
                                        </div>
                                        <br />
                                      </div>
                                      <div class="text-center">
                                        <ul
                                          class="pagination justify-content-center pagination-rounded"
                                        >
                                          <pagination
                                            :data="paginations"
                                            :limit="limit"
                                            @pagination-change-page="post"
                                          ></pagination>
                                        </ul>
                                      </div>
                                    </div>

                                    <div v-else class="justify-content-center row">
                                      <p class="text-center mt-2">No posts yet</p>
                                    </div>

                                    <hr class="my-4" />
                                  </div>
                                </div>
                              </div>
                              <div class="justify-content-center row" v-else>
                                <div class="col-xl-11">
                                  <div>
                                    <div class="text-left">
                                      <div class="row">
                                        <div class="text-left mb-2">
                                          <a
                                            href="#"
                                            class="router-link-active"
                                            @click="hideData"
                                          >
                                            <i class="bx bx-arrow-back"></i>
                                            Back
                                          </a>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div
                                          style="
                                            display: flex;
                                            align-items: center;
                                            width: 100% !important;
                                            justify-content: space-between;
                                          "
                                        >
                                          <div style="display: flex; align-items: center">
                                            <b-avatar
                                              variant="info"
                                              :src="postData.company.image_url"
                                              v-if="postData.company.image"
                                              class="mr-3"
                                            ></b-avatar>
                                            <b-avatar
                                              variant="info"
                                              :src="user_image"
                                              v-else
                                              class="mr-3"
                                            ></b-avatar>
                                            <div style="display: grid">
                                              <span class="font-size-18 mr-auto"
                                                >{{ postData.company.name }}
                                              </span>

                                              <small
                                                v-if="postData.created"
                                                class="text-muted"
                                                >{{
                                                  moment(postData.created).fromNow()
                                                }}</small
                                              >
                                              <small v-else class="text-muted">-</small>
                                            </div>
                                          </div>
                                          <b-dropdown
                                            class="float-right ml-5"
                                            toggle-class="text-muted p-0"
                                            right
                                            variant="white"
                                          >
                                            <template v-slot:button-content>
                                              <i
                                                class="mdi mdi-dots-horizontal font-size-18"
                                              ></i>
                                            </template>
                                            <b-dropdown-item
                                              @click="editPostName(postData.id)"
                                              v-if="
                                                !postData.repost_id &&
                                                !postData.parent_post
                                              "
                                              >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                              @click="deletePostName(postData.id)"
                                              >Delete</b-dropdown-item
                                            >
                                          </b-dropdown>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="mb-4 me-4">
                                      <input type="hidden" :value="postData.id" />
                                      <div v-if="!postData.repost_id">
                                        <div class="text-muted font-size-14">
                                          <p>{{ postData.post_description }}</p>
                                        </div>
                                        <div
                                          v-if="
                                            postData.website_url ||
                                            postData.posts_images.length > 0
                                          "
                                        >
                                          <div
                                            class="position-relative mb-3 mt-3"
                                            v-if="postData.website_url"
                                          >
                                            <div class="repost-border1">
                                              <a
                                                :href="postData.website_url"
                                                class="text-primary"
                                                target="_blank"
                                              >
                                                <div
                                                  class=""
                                                  style="width: 100% !important"
                                                >
                                                  <div
                                                    style="
                                                      display: flex;
                                                      align-items: center;
                                                      width: 100% !important;
                                                      justify-content: space-between;
                                                    "
                                                  >
                                                    <div
                                                      style="
                                                        display: flex;
                                                        align-items: center;
                                                      "
                                                    >
                                                      <img
                                                        :src="
                                                          postData.website_detail
                                                            .website_image
                                                        "
                                                        alt=""
                                                        v-if="
                                                          postData.website_detail
                                                            .website_image
                                                        "
                                                        style="
                                                          width: 100% !important;
                                                          object-fit: cover;
                                                        "
                                                        @error="companyimageNotFound"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div
                                                    style="
                                                      background-color: #e8e8e8;
                                                      width: 100% !important;
                                                      object-fit: cover;
                                                      padding: 10px;
                                                    "
                                                  >
                                                    <span
                                                      style="color: #000"
                                                      class="text-dark"
                                                      v-if="
                                                        postData.website_detail
                                                          .website_title
                                                      "
                                                    >
                                                      <h6>
                                                        {{
                                                          postData.website_detail
                                                            .website_title
                                                        }}
                                                      </h6>
                                                    </span>
                                                    <span
                                                      style="color: #000"
                                                      class="text-dark"
                                                      v-if="
                                                        postData.website_detail
                                                          .website_description
                                                      "
                                                    >
                                                      {{
                                                        postData.website_detail
                                                          .website_description
                                                      }}
                                                    </span>
                                                  </div>
                                                </div>
                                              </a>
                                            </div>
                                          </div>
                                          <div v-else>
                                            <div v-if="postData.posts_images.length > 1">
                                              <slider
                                                animation="fade"
                                                style="width: 100% !important"
                                              >
                                                <slider-item
                                                  v-for="index in postData.posts_images"
                                                  :key="index"
                                                >
                                                  <img
                                                    :src="
                                                      index.image_path + '/' + index.image
                                                    "
                                                    style="
                                                      height: 300px !important;
                                                      width: 100% !important;
                                                      object-fit: cover;
                                                    "
                                                    @error="imageNotFound"
                                                  />
                                                </slider-item>
                                              </slider>
                                            </div>
                                            <div
                                              v-else-if="
                                                postData.posts_images.length == 1
                                              "
                                            >
                                              <img
                                                :src="
                                                  postData.posts_images[0].image_path +
                                                  '/' +
                                                  postData.posts_images[0].image
                                                "
                                                alt=""
                                                v-if="
                                                  postData.posts_images[0].type == 'Image'
                                                "
                                                class="img-thumbnail"
                                                style="
                                                  width: 100% !important;
                                                  object-fit: cover;
                                                "
                                                @error="imageNotFound"
                                              />
                                              <!-- height: 300px !important; -->
                                              <video
                                                style="
                                                  height: auto !important;
                                                  width: 100% !important;
                                                  object-fit: cover;
                                                "
                                                v-if="
                                                  postData.posts_images[0].type == 'Video'
                                                "
                                                controls
                                                :src="
                                                  postData.posts_images[0].image_path +
                                                  '/' +
                                                  postData.posts_images[0].image
                                                "
                                              ></video>
                                              <div
                                                class="embed-responsive embed-responsive-16by9"
                                                v-if="
                                                  postData.posts_images[0].type == 'File'
                                                "
                                                style="margin-bottom: -115px !important"
                                              >
                                                <iframe
                                                  class="embed-responsive-item vue_frame"
                                                  :src="
                                                    postData.posts_images[0].image_path +
                                                    '/' +
                                                    postData.posts_images[0].image
                                                  "
                                                ></iframe>
                                              </div>
                                            </div>
                                            <div v-else>
                                              <img
                                                :src="default_image"
                                                alt=""
                                                class="img-thumbnail"
                                                style="
                                                  width: 100% !important;
                                                  object-fit: cover;
                                                "
                                              />
                                              <!-- height: 300px !important; -->
                                            </div>
                                          </div>
                                        </div>
                                        <div v-else></div>
                                        <div class="mt-3 text-muted font-size-14">
                                          <ul
                                            class="list-inline"
                                            style="
                                              display: flex;
                                              justify-content: space-between;
                                            "
                                          >
                                            <li class="list-inline-item">
                                              <a
                                                class="text-muted"
                                                href="javascript:void(0)"
                                                @click="getToggelData(postData.id)"
                                              >
                                                <i
                                                  class="bx bx-like align-middle text-muted me-1"
                                                ></i>
                                                {{ postData.like_users.length }} Likes
                                              </a>
                                            </li>
                                            <li class="list-inline-item">
                                              <i
                                                class="bx bx-comment-dots align-middle text-muted me-1"
                                              ></i>
                                              {{ postData.comments.length }} Comments
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <div class="pb-3 pt-3 pr-2 pl-2" v-else>
                                        <div
                                          v-if="
                                            postData.repost_id && postData.parent_post
                                          "
                                        >
                                          <div class="repost-border pr-2 pl-2">
                                            <a
                                              class="text-dark"
                                              href="#"
                                              v-on:click="isHidden = false"
                                              @click="
                                                showPostDetail(postData.parent_post.id)
                                              "
                                            >
                                              <div class="p-3">
                                                <div
                                                  style="
                                                    display: flex;
                                                    align-items: center;
                                                    width: 100% !important;
                                                    justify-content: space-between;
                                                  "
                                                >
                                                  <div
                                                    style="
                                                      display: flex;
                                                      align-items: center;
                                                    "
                                                    v-if="
                                                      postData.parent_post.company &&
                                                      postData.parent_post.is_company == 1
                                                    "
                                                  >
                                                    <b-avatar
                                                      variant="info"
                                                      :src="
                                                        postData.parent_post.company
                                                          .image_url
                                                      "
                                                      class="mr-3"
                                                      v-if="
                                                        postData.parent_post.company.image
                                                      "
                                                    ></b-avatar>
                                                    <b-avatar
                                                      variant="info"
                                                      :src="company_image"
                                                      class="mr-3"
                                                      v-else
                                                    ></b-avatar>
                                                    <div style="display: grid">
                                                      <span
                                                        class="font-size-15 mr-auto text-dark"
                                                        >{{
                                                          postData.parent_post.company
                                                            .name
                                                        }}</span
                                                      >
                                                      <small
                                                        v-if="
                                                          postData.parent_post.created_at
                                                        "
                                                        class="text-muted"
                                                        >{{
                                                          moment(
                                                            postData.parent_post
                                                              .created_at
                                                          ).fromNow()
                                                        }}
                                                      </small>
                                                      <small v-else class="text-muted"
                                                        >-</small
                                                      >
                                                    </div>
                                                  </div>

                                                  <div
                                                    style="
                                                      display: flex;
                                                      align-items: center;
                                                    "
                                                    v-if="
                                                      postData.parent_post.user &&
                                                      postData.parent_post.is_company == 0
                                                    "
                                                  >
                                                    <b-avatar
                                                      variant="info"
                                                      :src="postData.parent_post.user.id"
                                                      class="mr-3"
                                                      v-if="postData.parent_post.user.id"
                                                    ></b-avatar>
                                                    <b-avatar
                                                      variant="info"
                                                      :src="user_image"
                                                      class="mr-3"
                                                      v-else
                                                    ></b-avatar>
                                                    <div style="display: grid">
                                                      <span
                                                        class="font-size-15 mr-auto text-dark"
                                                        >{{
                                                          postData.parent_post.user.name
                                                        }}</span
                                                      >

                                                      <small
                                                        v-if="
                                                          postData.parent_post.created_at
                                                        "
                                                        class="text-muted"
                                                        >{{
                                                          moment(
                                                            postData.parent_post
                                                              .created_at
                                                          ).fromNow()
                                                        }}</small
                                                      >
                                                      <small v-else class="text-muted"
                                                        >-</small
                                                      >
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="pl-3 pr-3">
                                                <div
                                                  v-html="
                                                    postData.parent_post.post_description
                                                  "
                                                  id="app"
                                                  style="white-space: pre-wrap"
                                                  class="text-dark"
                                                  v-if="
                                                    postData.parent_post.post_description
                                                      .length < 500
                                                  "
                                                ></div>

                                                <div
                                                  v-html="
                                                    postData.parent_post.post_description.substring(
                                                      0,
                                                      500
                                                    ) + '..'
                                                  "
                                                  id="app"
                                                  style="white-space: pre-wrap"
                                                  class="text-dark pt-3"
                                                  v-else
                                                ></div>
                                                <div
                                                  v-if="
                                                    postData.parent_post.post_description
                                                      .length > 500
                                                  "
                                                  class="mb-2"
                                                >
                                                  <router-link
                                                    :to="{
                                                      name: 'company.newsfeeds.show',
                                                      params: { id: postData.id },
                                                    }"
                                                    class="text-primary"
                                                    >Read more
                                                    <i class="mdi mdi-arrow-right"></i
                                                  ></router-link>
                                                </div>

                                                <div
                                                  v-if="
                                                    postData.parent_post.website_url ||
                                                    postData.parent_post.posts_images
                                                      .length > 0
                                                  "
                                                >
                                                  <div
                                                    class="position-relative mb-3 mt-3"
                                                    v-if="
                                                      postData.parent_post.website_url
                                                    "
                                                  >
                                                    <a
                                                      :href="
                                                        postData.parent_post.website_url
                                                      "
                                                      class="text-primary"
                                                      target="_blank"
                                                      >{{
                                                        postData.parent_post.website_url
                                                      }}</a
                                                    >

                                                    <div class="repost-border1">
                                                      <a
                                                        :href="
                                                          postData.parent_post.website_url
                                                        "
                                                        class="text-primary"
                                                        target="_blank"
                                                      >
                                                        <div
                                                          class=""
                                                          style="width: 100% !important"
                                                        >
                                                          <div
                                                            style="
                                                              display: flex;
                                                              align-items: center;
                                                              width: 100% !important;
                                                              justify-content: space-between;
                                                            "
                                                          >
                                                            <div
                                                              style="
                                                                display: flex;
                                                                align-items: center;
                                                              "
                                                            >
                                                              <img
                                                                :src="
                                                                  postData.parent_post
                                                                    .website_detail
                                                                    .website_image
                                                                "
                                                                alt=""
                                                                v-if="
                                                                  postData.parent_post
                                                                    .website_detail
                                                                    .website_image
                                                                "
                                                                style="
                                                                  width: 100% !important;
                                                                  object-fit: cover;
                                                                "
                                                                @error="
                                                                  companyimageNotFound
                                                                "
                                                              />
                                                            </div>
                                                          </div>
                                                          <div
                                                            style="
                                                              background-color: #e8e8e8;
                                                              width: 100% !important;
                                                              object-fit: cover;
                                                              padding: 10px;
                                                            "
                                                          >
                                                            <span
                                                              style="color: #000"
                                                              class="text-dark"
                                                              v-if="
                                                                postData.parent_post
                                                                  .website_detail
                                                                  .website_title
                                                              "
                                                            >
                                                              <h6>
                                                                {{
                                                                  postData.parent_post
                                                                    .website_detail
                                                                    .website_title
                                                                }}
                                                              </h6>
                                                            </span>
                                                            <span
                                                              style="color: #000"
                                                              class="text-dark"
                                                              v-if="
                                                                postData.parent_post
                                                                  .website_detail
                                                                  .website_description
                                                              "
                                                            >
                                                              {{
                                                                postData.parent_post
                                                                  .website_detail
                                                                  .website_description
                                                              }}
                                                            </span>
                                                          </div>
                                                        </div>
                                                      </a>
                                                    </div>
                                                  </div>
                                                  <div
                                                    class="position-relative mb-3 mt-3"
                                                    v-else
                                                  >
                                                    <div
                                                      v-if="
                                                        postData.parent_post.posts_images
                                                          .length > 1
                                                      "
                                                    >
                                                      <slider
                                                        animation="fade"
                                                        height="400px"
                                                        width="auto"
                                                      >
                                                        <slider-item
                                                          v-for="(
                                                            image, index
                                                          ) in postData.parent_post
                                                            .posts_images"
                                                          :key="index"
                                                        >
                                                          <img
                                                            :src="
                                                              image.image_path +
                                                              '/' +
                                                              image.image
                                                            "
                                                            width="665px;"
                                                            style="
                                                              height: 400px !important;
                                                            "
                                                            @error="imageNotFound"
                                                          />
                                                        </slider-item>
                                                      </slider>
                                                    </div>
                                                    <div
                                                      v-else-if="
                                                        postData.parent_post.posts_images
                                                          .length == 1
                                                      "
                                                    >
                                                      <video
                                                        style="
                                                          height: auto !important;
                                                          width: 100% !important;
                                                          object-fit: cover;
                                                        "
                                                        v-if="
                                                          postData.parent_post
                                                            .posts_images[0].type ==
                                                          'Video'
                                                        "
                                                        controls
                                                        :src="
                                                          postData.parent_post
                                                            .posts_images[0].image_path +
                                                          '/' +
                                                          postData.parent_post
                                                            .posts_images[0].image
                                                        "
                                                      ></video>

                                                      <img
                                                        :src="
                                                          postData.parent_post
                                                            .posts_images[0].image_path +
                                                          '/' +
                                                          postData.parent_post
                                                            .posts_images[0].image
                                                        "
                                                        alt=""
                                                        v-if="
                                                          postData.parent_post
                                                            .posts_images[0].type ==
                                                          'Image'
                                                        "
                                                        class="img-thumbnail"
                                                        width="100%"
                                                        @error="imageNotFound"
                                                      />
                                                      <!-- style="
                                                          height: 400px !important;
                                                          width: 100% !important;
                                                        " -->
                                                      <div
                                                        class="embed-responsive embed-responsive-16by9"
                                                        v-if="
                                                          postData.parent_post
                                                            .posts_images[0].type ==
                                                          'File'
                                                        "
                                                      >
                                                        <iframe
                                                          class="embed-responsive-item vue_frame"
                                                          :src="
                                                            postData.parent_post
                                                              .posts_images[0]
                                                              .image_path +
                                                            '/' +
                                                            postData.parent_post
                                                              .posts_images[0].image
                                                          "
                                                        ></iframe>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div v-else></div>
                                                <ul
                                                  class="list-inline"
                                                  style="
                                                    display: flex;
                                                    justify-content: space-between;
                                                  "
                                                >
                                                  <li class="list-inline-item">
                                                    <i
                                                      class="bx bx-like align-middle text-muted me-1"
                                                    ></i>
                                                    {{
                                                      postData.parent_post.like_admin
                                                        .length +
                                                      postData.parent_post.like_companies
                                                        .length +
                                                      postData.parent_post.like_users
                                                        .length
                                                    }}
                                                    Likes
                                                  </li>
                                                  <li class="list-inline-item">
                                                    <i
                                                      class="bx bx-comment-dots align-middle text-muted me-1"
                                                    ></i>
                                                    {{
                                                      postData.parent_post.comments.length
                                                    }}
                                                    Comments
                                                  </li>
                                                </ul>
                                              </div>
                                            </a>
                                          </div>
                                          <ul
                                            class="list-inline pt-3"
                                            style="
                                              display: flex;
                                              justify-content: space-between;
                                            "
                                          >
                                            <li class="list-inline-item">
                                              <a
                                                class="text-muted"
                                                href="javascript:void(0)"
                                                @click="getToggelData(postData.id)"
                                                ><i
                                                  class="bx bx-like align-middle text-muted me-1"
                                                ></i>
                                                {{
                                                  postData.like_users.length +
                                                  postData.like_companies.length +
                                                  postData.like_admin.length
                                                }}
                                                Likes</a
                                              >
                                            </li>
                                            <li class="list-inline-item">
                                              <router-link
                                                :to="{
                                                  name: 'post.show',
                                                  params: { id: postData.id },
                                                }"
                                                class="text-muted"
                                              >
                                                <i
                                                  class="bx bx-comment-dots align-middle text-muted me-1"
                                                ></i>
                                                {{ postData.comments.length }} Comments
                                              </router-link>

                                              <!-- <a class="text-muted" href="/blog-list"
                                ><i
                                  class="bx bx-comment-dots align-middle text-muted me-1"
                                ></i>
                                {{ post.comment_count }} Comments</a
                              > -->
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                      <hr class="my-1" />
                                      <div class="pl-3 pr-3 pt-2">
                                        <ul
                                          class="list-inline text-muted"
                                          style="
                                            display: flex;
                                            justify-content: space-between;
                                          "
                                        >
                                          <li
                                            class="list-inline-item w-50 likes-post"
                                            v-if="postData.like_admin.length > 0"
                                            style="text-align: center"
                                          >
                                            <a
                                              @click="likes(postData.id)"
                                              class="text-muted"
                                              href="javascript:void(0)"
                                            >
                                              <i
                                                class="bx bxs-like align-middle text-muted me-1 bx-sm"
                                              ></i>
                                            </a>
                                          </li>
                                          <li
                                            class="list-inline-item w-50 likes-post"
                                            v-else
                                            style="text-align: center"
                                          >
                                            <a
                                              @click="likes(postData.id)"
                                              class="text-muted"
                                              href="javascript:void(0)"
                                            >
                                              <i
                                                class="bx bx-like align-middle text-muted me-1 bx-sm"
                                              ></i>
                                            </a>
                                          </li>

                                          <li
                                            class="list-inline-item w-50"
                                            style="text-align: center"
                                          >
                                            <a
                                              @click="comments(postData.id)"
                                              class="text-muted"
                                              href="javascript:void(0)"
                                            >
                                              <i
                                                class="bx bx-comment-dots align-middle text-muted me-1 bx-sm"
                                              ></i>
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>

                                    <div class="">
                                      <hr />

                                      <div class="mt-5">
                                        <h5 class="font-size-15">
                                          <i
                                            class="bx bx-message-dots text-muted align-middle me-1"
                                          ></i>
                                          Comments :
                                        </h5>
                                        <div v-if="postData.comments.length > 0">
                                          <div
                                            v-for="comment in postData.comments"
                                            :key="comment.id"
                                          >
                                            <div class="media py-3">
                                              <div class="avatar-xs me-3">
                                                <div
                                                  class="avatar-title rounded-circle bg-light text-primary"
                                                >
                                                  <b-avatar
                                                    variant="info"
                                                    :src="image_url + '/' + comment.image"
                                                    v-if="comment.image"
                                                  ></b-avatar>
                                                  <b-avatar
                                                    variant="info"
                                                    :src="user_image"
                                                    v-else
                                                  ></b-avatar>
                                                </div>
                                              </div>

                                              <div class="media-body">
                                                <h5
                                                  class="font-size-14 mb-1"
                                                  style="margin-left: 10px"
                                                >
                                                  {{ comment.name }}
                                                  <small class="text-muted float-end">{{
                                                    moment(comment.created_at).fromNow()
                                                  }}</small>
                                                </h5>
                                                <br />
                                                <p class="text-muted ml-3">
                                                  {{ comment.comment }}
                                                </p>
                                                <!-- 
                                                    <div>
                                                      <a
                                                        class="text-success"
                                                        href="/blog-details"
                                                      >
                                                        <i class="mdi mdi-reply"></i> Reply
                                                      </a>
                                                    </div> -->
                                                <div
                                                  class="media border-top"
                                                  style="
                                                    margin-bottom: -16px;
                                                    margin-top: 18px;
                                                  "
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div v-else class="justify-content-center row">
                                          <label class="align-middle mt-2"
                                            >No comments yet</label
                                          >
                                        </div>
                                      </div>
                                      <div class="mt-4" v-if="commentSeen">
                                        <h5 class="font-size-16 mb-3">Leave a Message</h5>
                                        <form @submit.prevent="create(postData.id)">
                                          <div class="mb-3 mb-3">
                                            <label
                                              for="commentmessage-input"
                                              class="form-label form-label"
                                              >Message</label
                                            ><textarea
                                              class="form-control"
                                              id="commentmessage-input"
                                              placeholder="Your message..."
                                              rows="3"
                                              v-model="commentData.comment"
                                            ></textarea>
                                          </div>
                                          <div class="text-end">
                                            <button
                                              type="submit"
                                              class="btn btn-success w-sm"
                                              :disabled="isActive"
                                            >
                                              Submit
                                            </button>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <b-sidebar
                                id="sidebar-rigth"
                                title="Likes"
                                right
                                :visible="showSidebar"
                                ref="mySidebar"
                                backdrop
                                shadow
                                @hidden="showSidebar = false"
                              >
                                <div class="px-3 py-2">
                                  <b-tabs pills fill content-class="my-4">
                                    <b-card-text>
                                      <div>
                                        <h5 class="font-size-14 mb-3">Users</h5>
                                        <div style="max-height: 410px">
                                          <ul class="list-unstyled chat-list">
                                            <li
                                              class
                                              v-for="data of like_users"
                                              :key="data.id"
                                            >
                                              <a href="javascript: void(0);">
                                                <div class="media">
                                                  <div
                                                    class="align-self-center mr-3"
                                                    v-if="data.image"
                                                  >
                                                    <img
                                                      :src="
                                                        data.image_path + '/' + data.image
                                                      "
                                                      class="rounded-circle avatar-xs"
                                                      style="height:40px; !important; width:40px !important"
                                                      alt
                                                    />
                                                  </div>
                                                  <div
                                                    class="avatar-xs align-self-center mr-3"
                                                    v-if="!data.image"
                                                  >
                                                    <span
                                                      class="avatar-title rounded-circle bg-soft-primary text-primary"
                                                      >{{ data.name.charAt(0) }}</span
                                                    >
                                                    <span
                                                      class="badge badge-secondary"
                                                      v-if="data.role_id == '2'"
                                                      >company</span
                                                    >
                                                    <span
                                                      class="badge badge-secondary"
                                                      v-else
                                                      >user</span
                                                    >
                                                  </div>

                                                  <div class="media-body overflow-hidden">
                                                    <h5
                                                      class="text-truncate font-size-14"
                                                    >
                                                      {{ data.name }}
                                                    </h5>
                                                    <p class="text-truncate mb-0">
                                                      {{ data.email }}
                                                    </p>
                                                  </div>
                                                  <div class="font-size-11 text-muted">
                                                    {{
                                                      moment(
                                                        data["pivot"]["created_at"]
                                                      ).fromNow()
                                                    }}
                                                  </div>
                                                </div>
                                              </a>
                                              <hr class="mt-1 mb-1" />
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </b-card-text>
                                  </b-tabs>
                                </div>
                              </b-sidebar>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab
                      :title="'Followers' + '(' + followerCount + ')'"
                      @click="follower"
                    >
                      <div class="row list-table-main">
                        <div class="col-12">
                          <div class="card">
                            <div class="card-body">
                              <div class="row">
                                <div
                                  class="col-12 table-main-list customer-table table-responsive"
                                >
                                  <b-table
                                    :items="followers"
                                    :fields="usersData"
                                    :busy="loading"
                                    show-empty
                                  >
                                    <template #table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>{{ $t("loadingData") }}</strong>
                                      </div>
                                    </template>
                                    <template v-slot:cell(id)="usersData">
                                      <h5 class="font-size-14">
                                        <!-- @click="userDetails(usersData.item.id)" -->
                                        {{ usersData.item.id }}
                                      </h5>
                                    </template>
                                    <template v-slot:cell(name)="usersData">
                                      <div
                                        class="d-flex"
                                        @click="userDetails(usersData.item.id)"
                                      >
                                        <b-avatar
                                          v-if="usersData.item.image"
                                          variant="info"
                                          :src="image_url + '/' + usersData.item.image"
                                          class="mr-3"
                                        >
                                        </b-avatar>
                                        <b-avatar
                                          v-else
                                          variant="info"
                                          :src="user_image"
                                          class="mr-3"
                                        >
                                        </b-avatar>
                                        <div>
                                          <span class="font-size-15 mr-auto"
                                            >{{ usersData.item.name }}
                                          </span>
                                          <small
                                            class="text-muted"
                                            v-if="
                                              usersData.item.country_code &&
                                              usersData.item.phone_number
                                            "
                                            >{{
                                              usersData.item.phone_number
                                                ? "(" +
                                                  usersData.item.country_code +
                                                  " " +
                                                  usersData.item.phone_number +
                                                  ")"
                                                : ""
                                            }}</small
                                          >
                                          <br />
                                          <small class="text-secondary">{{
                                            usersData.item.email
                                          }}</small>
                                        </div>
                                      </div>
                                    </template>

                                    <!-- <template v-slot:cell(is_active)="usersData">
                                      <div @click="userDetails(usersData.item.id)">
                                        <div
                                          v-if="usersData.item.is_active == '1'"
                                          class="badge badge-pill badge-soft-success font-size-12"
                                        >
                                          Active
                                        </div>
                                        <div
                                          v-else
                                          class="badge badge-pill badge-soft-danger font-size-12"
                                        >
                                          InActive
                                        </div>
                                      </div>
                                    </template> -->
                                    <template #empty>
                                      <p class="text-center">No followers yet</p>
                                    </template>
                                  </b-table>
                                </div>
                                <div class="row col-sm-5 offset-sm-7">
                                  <div class="col">
                                    <div
                                      class="dataTables_paginate paging_simple_numbers float-right"
                                    >
                                      <ul class="pagination pagination-rounded mb-0">
                                        <pagination
                                          :data="paginations"
                                          :limit="limit"
                                          @pagination-change-page="follower"
                                        ></pagination>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab
                      :title="'Followings' + '(' + followingCount + ')'"
                      @click="following"
                    >
                      <div class="row list-table-main">
                        <div class="col-12">
                          <div class="card">
                            <div class="card-body">
                              <div class="row">
                                <div
                                  class="col-12 table-main-list customer-table table-responsive"
                                >
                                  <b-table
                                    :items="followings"
                                    :fields="followingsData"
                                    :busy="loading"
                                    show-empty
                                  >
                                    <template #table-busy>
                                      <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>{{ $t("loadingData") }}</strong>
                                      </div>
                                    </template>
                                    <template v-slot:cell(id)="followingsData">
                                      <h5 class="font-size-14">
                                        {{ followingsData.item.id }}
                                      </h5>
                                    </template>

                                    <template v-slot:cell(name)="followingsData">
                                      <div v-if="followingsData.item.type == 'user'">
                                        <div v-if="followingsData.item.user">
                                          <div class="d-flex">
                                            <b-avatar
                                              v-if="followingsData.item.user.image"
                                              variant="info"
                                              :src="
                                                followingsData.item.user.image_path +
                                                '/' +
                                                followingsData.item.user.image
                                              "
                                              class="mr-3"
                                            >
                                            </b-avatar>
                                            <b-avatar
                                              v-else
                                              variant="info"
                                              :src="user_image"
                                              class="mr-3"
                                            >
                                            </b-avatar>
                                            <div>
                                              <span class="font-size-15 mr-auto"
                                                >{{ followingsData.item.user.name }}
                                              </span>
                                              <small
                                                class="text-muted"
                                                v-if="
                                                  followingsData.item.user.country_code &&
                                                  followingsData.item.user.phone_number
                                                "
                                                >{{
                                                  followingsData.item.user.phone_number
                                                    ? "(" +
                                                      followingsData.item.user
                                                        .country_code +
                                                      " " +
                                                      followingsData.item.user
                                                        .phone_number +
                                                      ")"
                                                    : ""
                                                }}</small
                                              >
                                              <br />
                                              <small class="text-secondary">{{
                                                followingsData.item.user.email
                                              }}</small>
                                            </div>
                                          </div>
                                        </div>
                                        <div v-else>-</div>
                                      </div>
                                      <div v-else>
                                        <div v-if="followingsData.item.company">
                                          <div class="d-flex">
                                            <b-avatar
                                              v-if="followingsData.item.company.image"
                                              variant="info"
                                              :src="
                                                followingsData.item.company.image_path +
                                                '/' +
                                                followingsData.item.company.image
                                              "
                                              class="mr-3"
                                            >
                                            </b-avatar>
                                            <b-avatar
                                              v-else
                                              variant="info"
                                              :src="company_image"
                                              class="mr-3"
                                            >
                                            </b-avatar>
                                            <div>
                                              <span class="font-size-15 mr-auto"
                                                >{{ followingsData.item.company.name }}
                                              </span>
                                              <small
                                                class="text-muted"
                                                v-if="
                                                  followingsData.item.company
                                                    .country_code &&
                                                  followingsData.item.company.phone_number
                                                "
                                                >{{
                                                  followingsData.item.company.phone_number
                                                    ? "(" +
                                                      followingsData.item.company
                                                        .country_code +
                                                      " " +
                                                      followingsData.item.company
                                                        .phone_number +
                                                      ")"
                                                    : ""
                                                }}</small
                                              >
                                              <br />
                                              <small class="text-secondary">{{
                                                followingsData.item.company.email
                                              }}</small>
                                            </div>
                                          </div>
                                        </div>
                                        <div v-else>-</div>
                                      </div>

                                      <div class="d-flex"></div>
                                    </template>

                                    <template v-slot:cell(type)="followingsData">
                                      <h5 class="font-size-14">
                                        {{ followingsData.item.type }}
                                      </h5>
                                    </template>

                                    <!-- <template v-slot:cell(is_active)="followingsData">
                                      <div v-if="followingsData.item.type == 'user'">
                                        <div
                                          class="d-flex"
                                          v-if="followingsData.item.user"
                                        >
                                          <div
                                            v-if="
                                              followingsData.item.user.is_active == '1'
                                            "
                                            class="badge badge-pill badge-soft-success font-size-12"
                                          >
                                            Active
                                          </div>
                                          <div
                                            v-else
                                            class="badge badge-pill badge-soft-danger font-size-12"
                                          >
                                            InActive
                                          </div>
                                        </div>
                                        <div class="d-flex" v-else>-</div>
                                      </div>
                                      <div class="d-flex" v-else>
                                        <div
                                          class="d-flex"
                                          v-if="followingsData.item.company"
                                        >
                                          <div
                                            v-if="
                                              followingsData.item.company.is_active == '1'
                                            "
                                            class="badge badge-pill badge-soft-success font-size-12"
                                          >
                                            Active
                                          </div>
                                          <div
                                            v-else
                                            class="badge badge-pill badge-soft-danger font-size-12"
                                          >
                                            InActive
                                          </div>
                                        </div>
                                        <div class="d-flex" v-else>-</div>
                                      </div>
                                    </template> -->

                                    <template #empty>
                                      <p class="text-center">No followings yet</p>
                                    </template>
                                  </b-table>
                                </div>
                                <div class="row col-sm-5 offset-sm-7">
                                  <div class="col">
                                    <div
                                      class="dataTables_paginate paging_simple_numbers float-right"
                                    >
                                      <ul class="pagination pagination-rounded mb-0">
                                        <pagination
                                          :data="paginations"
                                          :limit="limit"
                                          @pagination-change-page="following"
                                        ></pagination>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-tab>

                    <b-tab title="About">
                      <div v-if="user.address">
                        <!-- <div style="border: 2px solid #495057">
                              <span v-html="user.address" class="m-3"></span>
                            </div> -->
                        <textarea
                          type="text"
                          class="text-muted"
                          style="
                            height: 150px !important;
                            width: 100% !important;
                            padding: 10px !important;
                            border: 1px solid #ced4da;
                          "
                          v-model="user.address"
                          readonly
                        />
                      </div>

                      <div v-else class="justify-content-center row">
                        <p class="text-center mt-3">Nothing to show</p>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </form>

            <!-- <div class="row">
                  <div class="col-12 table-main-list customer-table table-responsive">
                    <b-table  
                      :items="posts"
                      :fields="fields"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :no-local-sorting="true"
                      @sort-changed="sortingChanged"
                      :busy="loading"
                      show-empty
                    >
                      <template #table-busy>
                        <div class="text-center text-danger my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>{{ $t("loadingData") }}</strong>
                        </div>
                      </template>
                      <template v-slot:cell(id)="data">
                        <span class="font-size-14 align-self-center">{{ data.item.id }}</span>
                      </template>
                      <template v-slot:cell(post_description)="data">
                        <h5 class="font-size-14">{{ data.item.post_description }}</h5>
                      </template>
                      <template v-slot:cell(is_active)="data">
                        <div
                          v-if="data.item.is_active == '1'"
                          class="badge badge-pill badge-soft-success font-size-12 mt-2"
                        >
                          Active
                        </div>
                        <div
                          v-else
                          class="badge badge-pill badge-soft-danger font-size-12 mt-2"
                        >
                          InActive
                        </div>
                      </template>
                      <template v-slot:cell(action)="data">
                        <div class="page-title-right d-flex">
                          <router-link :to="{ name: 'post.edit' , params: { id: data.item.id }, }" class="btn btn-success btn-rounded mr-2 add-btn">
                            Edit
                          </router-link>
                          <router-link :to="{ name: 'post.show' , params: { id: data.item.id }, }" class="btn btn-primary btn-rounded mr-2 add-btn">
                            Show
                          </router-link>
                          <button @click="deletePostName(data.item.id)" class="btn btn-danger btn-rounded export-btn">Delete</button>    
                        </div>
                      </template>
                      <template #empty>
                        <p class="text-center">{{ $t("companyManagement.no_post") }}</p>
                      </template>
                    </b-table>
                  </div>
                  <div class="row col-sm-5 offset-sm-7">
                    <div class="col">
                      <div class="dataTables_paginate paging_simple_numbers float-right">
                        <ul class="pagination pagination-rounded mb-0">
                          <pagination :data="paginations" :limit="limit"
                            @pagination-change-page="getPosts "></pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>  -->
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="date-range-list">
                  <label>Search :</label>
                  <div class="text-sm">
                    <div class="search-box mr-2 d-inline-block w-100">
                      <div class="position-relative">
                        <input
                          type="text"
                          class="form-control rounded-sm mb-3"
                          id="search"
                          @input="searchData(type)"
                          v-model="search"
                          :placeholder="$t('navbar.search.text')"
                        />
                        <i class="bx bx-search-alt search-icon"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Per Page :</label>
                    <select
                      class="custom-select"
                      v-model="perPage"
                      @change="searchData(type)"
                    >
                      <option value="2" selected>2</option>
                      <option value="10">10</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- <div class="col-sm-12">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Status :</label>
                    <select
                      class="custom-select"
                      v-model="status"
                      @change="searchData(type)"
                    >
                      <option value="">Both</option>
                      <option value="1" selected>Active</option>
                      <option value="0">InActive</option>
                    </select>
                  </div>
                </div>
              </div> -->
              <div class="col-sm-12" v-if="isHidden == false">
                <div class="form-group">
                  <div class="date-range-list">
                    <label>Report :</label>
                    <div v-if="postData.postreport.length > 0">
                      <div
                        class="mt-2"
                        v-for="report in postData.postreport"
                        :key="report.id"
                      >
                        <a href="javascript: void(0);" class="media">
                          <img
                            class="d-flex mr-3 rounded-circle"
                            :src="url + '/' + report.image"
                            alt="Generic placeholder image"
                            height="36"
                            v-if="report.image"
                          />
                          <img
                            class="d-flex mr-3 rounded-circle"
                            :src="user_image"
                            alt="Generic placeholder image"
                            height="36"
                            v-else
                          />

                          <div class="media-body chat-user-box">
                            <p class="user-title m-0">{{ report.name }}</p>
                            <p class="text-muted">{{ report.message }}</p>
                          </div>
                          <div class="font-size-11">{{ report.created }}</div>
                        </a>
                      </div>
                    </div>
                    <div class="mt-2" v-else>
                      <span class="align-self-center">no data</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.vue_frame {
  height: 250px !important;
}
.repost-border {
  border: 1px solid;
  border-color: #d0d0d0;
}
.likes-post:not(:last-child) {
  border-right: 2px solid #e3e4ea !important;
}
</style>
